"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _codemirror = _interopRequireDefault(require("codemirror/lib/codemirror.js"));

var _advanced = _interopRequireDefault(require("./advanced"));

var _advancedSmall = _interopRequireDefault(require("./advanced-small"));

var _headline = _interopRequireDefault(require("./headline"));

var _simple = _interopRequireDefault(require("./simple"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var defaultConfig = {
  placeholderText: '',
  useClases: false,
  charCounterCount: true,
  codeMirror: _codemirror.default,
  imageInsertButtons: ['imageUpload', 'imageByURL', 'showFilestack'],
  requestHeaders: {
    'X-CSRF-Token': (0, _util.csrfToken)()
  },
  htmlExecuteScripts: false,
  emoticonsUseImage: false,
  linkAutoPrefix: 'https://',
  imageSplitHTML: true,
  linkAlwaysBlank: true,
  linkInsertButtons: [],
  videoMaxSize: 30 * 1024 * 1024,
  fileMaxSize: 25 * 1024 * 1024,
  imageMaxSize: 10 * 1024 * 1024,
  fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '36', '48', '60', '72', '96'],
  pasteAllowedStyleProps: ['font-size', 'color', 'font-weight', 'font-style', 'text-decoration', 'vertical-align'],
  events: {
    'initialized': function initialized() {
      this.opts.setEditor(this);
      this.isCodeViewActive = false;

      if (this.opts.disabled) {
        this.edit.off();
      }
    },
    'focus': function focus() {
      this.isFocused = true;
    },
    'blur': function blur() {
      this.isFocused = false;

      if (this.opts.onBlur) {
        var html = this.html.get();
        this.opts.onBlur(html, (0, _util.extractText)(html));
      }
    },
    'commands.after': function commandsAfter(cmd) {
      if (cmd !== 'html') return;
      var isCodeViewActive = this.codeView.isActive();
      this.opts.setShowSave(isCodeViewActive);

      if (this.isCodeViewActive !== isCodeViewActive) {
        this.opts.onCodeViewToggle(isCodeViewActive);
        this.isCodeViewActive = isCodeViewActive;
      }
    }
  }
};
var configsMap = {
  'advanced': _advanced.default,
  'advanced-small': _advancedSmall.default,
  'simple': _simple.default,
  'headline': _headline.default
};

var _default = function _default(variant, options) {
  return R.mergeDeepRight(defaultConfig, configsMap[variant](options));
};

exports.default = _default;